import { LOAN_TYPES } from "@loanbossinc/component-library";

export const loanTypeList = [
  { label: "", name: "None", value: "", isAssumptionType: true },
  { label: "Balance Sheet", name: "Balance Sheet", value: 4, isAssumptionType: true },
  { label: "Bridge", name: "Bridge", value: 5, isAssumptionType: true },
  { label: "CMBS", name: "CMBS", value: 3, isAssumptionType: true },
  { label: "Construction", name: "Construction", value: 1, isAssumptionType: true },
  { label: "Freddie Mac", name: "Freddie Mac", value: 7, isAssumptionType: true },
  { label: "Fannie Mae", name: "Fannie Mae", value: 6, isAssumptionType: true },
  { label: "HUD", name: "HUD", value: 8, isAssumptionType: true },
  { label: "Life Co", name: "Life Co", value: 11, isAssumptionType: true },
  { label: "Line of Credit", name: "Line of Credit", value: 13, isAssumptionType: false },
  { label: "Value Add", name: "Value Add", value: 10, isAssumptionType: true },
  { label: "Other", name: "Other", value: 2, isAssumptionType: false },
  { label: "Mezz", name: "Mezz", value: 12, isAssumptionType: false },
  { label: "Pref. Equity", name: "Pref. Equity", value: 9, isAssumptionType: false },
  { label: "Agency", name: "Agency", value: 14, isAssumptionType: true }
];

export const LenderLoanTypeList = [
  { label: "Balance Sheet", name: "Balance Sheet", value: LOAN_TYPES.BALANCE_SHEET },
  { label: "CMBS", name: "CMBS", value: LOAN_TYPES.CMBS },
  { label: "Fannie Mae", name: "Fannie Mae", value: LOAN_TYPES.FANNIE_MAE },
  { label: "Freddie Mac", name: "Freddie Mac", value: LOAN_TYPES.FREDDIE_MAC },
  { label: "HUD", name: "HUD", value: LOAN_TYPES.HUD },
  { label: "Life Co", name: "Life Co", value: LOAN_TYPES.LIFE_CO },
  { label: "Value Add", name: "Value Add", value: LOAN_TYPES.VALUE_ADD }
];

export default {
  NONE: "",
  CONSTRUCTION: 1,
  VALUE_ADD: 10,
  BALANCE_SHEET: 4,
  BRIDGE: 5,
  CMBS: 3,
  FANNIE_MAE: 6,
  FREDDIE_MAC: 7,
  HUD: 8,
  OTHER_TYPE: 2,
  PREF_EQUITY: 9,
  LIFE_CO: 11,
  MEZZ: 12,
  LINE_OF_CREDIT: 13,
  AGENCY: 14
};
